import { ApiClientsContext } from 'contexts/ApiClientsContext';
import { useContext } from 'react';

export default () => useContext(ApiClientsContext);
